import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { consumePostAuthRedirectNotice } from '../utils/postAuthNavigation';

const PostAuthRedirectNotice = () => {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const notice = consumePostAuthRedirectNotice();
    if (notice) {
      setMessage(notice);
    }
  }, []);

  return (
    <Snackbar
      open={Boolean(message)}
      autoHideDuration={8000}
      onClose={() => setMessage(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="info" onClose={() => setMessage(null)} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default PostAuthRedirectNotice;
